(function () {
    'use strict';

    angular
        .module('app.clubAdmin')
        .component('sc3AddMember', {
            templateUrl: 'app/club-admin/add-member/add-member.component.html',
            controller: AddMemberComponent,
            bindings: {
                member: '<',
                isLegacy: '<',
                clubHoleType: '<'
            }
        });

    AddMemberComponent.$inject = ['Member', '$locale', '$state', 'alert', 'gender', 'holeType', 'cultureName', 'clubMembershipLevelType', 'clubAdminResources', 'statusCodes', 'clubMembershipCategory'];
    function AddMemberComponent(Member, $locale, $state, alert, gender, holeType, cultureName, clubMembershipLevelType, resources, statusCodes, clubMembershipCategory) {
        // Variables
        var ctrl = this,
            club = $state.params.club;

        // Properties
        ctrl.genderList = [gender.Male, gender.Female];
        ctrl.holeList = [holeType.EighteenHoles, holeType.NineHoles];
        Object.defineProperty(ctrl, 'showHoleType', { get: function () { return ctrl.clubHoleType === holeType.Both; } });
        ctrl.cultureList = [cultureName.en_CA, cultureName.fr_CA];
        ctrl.categories = Object.keys(clubMembershipCategory.$metadata);
        ctrl.levelList = [clubMembershipLevelType.Gold].concat(club.clubManagementGroupId !== 7 ? clubMembershipLevelType.Bronze : []);
        ctrl.datePickerOptions = { minDate: getMinDate(), maxDate: getMaxDate() };
        Object.defineProperty(ctrl, 'dateFormat', { get: getDataFormat });

        // Methods
        ctrl.submit = submit;
        ctrl.$onInit = init;
        /////////////////////////
        function init() {
            var clubHoleType = ctrl.clubHoleType;
            if (clubHoleType != holeType.Both) {
                ctrl.holeList = ctrl.holeList.filter(function (holeType) { return holeType === clubHoleType; });
            }
        }

        function getDataFormat() {
            return $locale.DATETIME_FORMATS.shortDate.toLowerCase();
        }

        function submit() {
            if (ctrl.form.$valid) {
                Member.addMember(ctrl.member, success, error, true);
            }

            function success() {
                alert.success(format(resources.memberAddSucceeded));
                $state.reload();
            }
            function error(response) {
                var status = response.status,
                    serverMessage = response.data.message,
                    showServerMessage = serverMessage && (status === statusCodes.badRequest || status === statusCodes.unauthorized),
                    message = showServerMessage ? serverMessage : format(resources.memberAddFailed);

                alert.error(message);
            }

            function format(message) {
                var member = ctrl.member,
                    club = $state.params.club;
                return message.format(member.firstName, member.lastName, club.name);
            }

        }

        function getMinDate() {
            var now = new Date();
            now.setYear(now.getFullYear() - 110);
            return now;
        }

        function getMaxDate() {
            var now = new Date();
            return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999); // end of day
        }
    }
})();